import { gql, useMutation } from '@apollo/client'

const mutation = gql`
  mutation muteUsername($muteeId: String!) {
    muteUser(muteeId: $muteeId) {
      success
      message
    }
  }
`

export interface MuteUsernameInput {
  muteeId: string
}

export interface MuteUsernameOutput {
  muteUser: {
    success: boolean
    message: string
  }
}

export const useMuteUsername = () => useMutation<MuteUsernameOutput, MuteUsernameInput>(mutation)
